import React, { useState, useEffect } from 'react';
import '../styles/CookiePopup.css';

function CookiePopup() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const cookieConsent = localStorage.getItem('cookie_consent_granted');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent_granted', 'true');
    
    // Update Google Consent Mode
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted',
        'ad_data': 'granted',
        'personalization_storage': 'granted'
      });
    }
    
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent_granted', 'false');
    
    // Keep Google Consent Mode as denied (already set by default)
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'ad_data': 'denied',
        'personalization_storage': 'denied'
      });
    }
    
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-popup">
      <div className="cookie-content">
        <button className="cookie-close" onClick={handleClose} aria-label="Close">
          ×
        </button>
        <h3 className="cookie-title">Cookie-uri și confidențialitate</h3>
        <p className="cookie-text">
          Folosim cookie-uri pentru a îmbunătăți experiența ta pe site-ul nostru și pentru a analiza traficul. 
          Acceptând, ești de acord cu utilizarea cookie-urilor conform politicii noastre de confidențialitate.
        </p>
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Accept
          </button>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Refuz
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookiePopup;

















